//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import has from 'lodash/has'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'

export default {
  name: 'rb-seo-related-links',

  data() {
    return {
      categoryLinks: [],
    }
  },

  computed: {
    isMobileOrTablet() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },

    isSeoVisible() {
      return this.categoryLinks.length > 0
    },

    isCarouselVisible() {
      return this.categoryLinks.length > 2
    },

    defaultConfig() {
      return {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 8,
        touchStartPreventDefault: false,
      }
    },
    title() {
      const category = document.getElementById('pageType')?.value
      if (category === 'sunglasses_view-all') {
        return this.$t('plp.seo_link_section.sunglasses')
      }
      if (category === 'eyeglasses_view-all') {
        return this.$t('plp.seo_link_section.eyeglasses')
      }
      return ''
    },
  },
  mounted() {
    if (document.readyState === 'complete') {
      this.bootCategoryLinks()
    } else {
      document.addEventListener(
        'readystatechange',
        (e) => {
          if (e.target.readyState === 'complete') this.bootCategoryLinks()
        },
        false
      )
    }
  },
  beforeDestroy() {
    document.removeEventListener(('readystatechange', this.bootCategoryLinks))
  },
  methods: {
    bootCategoryLinks() {
      const scriptElements = document.querySelectorAll('script[type="application/ld+json"]')
      let categoryLinks = []

      scriptElements.forEach((scriptElement) => {
        const jsonData = JSON.parse(scriptElement.textContent || '{}')
        if (Array.isArray(jsonData) && !jsonData?.isEmpty) {
          jsonData.forEach((item) => {
            if (has(item, 'eyewear:categoryRelatedLinks')) {
              categoryLinks = item['eyewear:categoryRelatedLinks']
            }
          })
        }
      })

      this.categoryLinks = categoryLinks
    },
  },
}
